import store from '@/store'

//OWHS-10467 - 【OT】指定商品不可购买
const isGoodsColorDisabled = (id, color) => {
  if (!id || !color) {
    return true;
  }
  let disabledGoodsColor = store.state.commonConfig?.["DISABLED_GOODS_COLOR"];
  if (disabledGoodsColor?.length) {
    return disabledGoodsColor.includes(`${id}-${color}`);
  } else {
    return false;
  }
};

export default {
  isGoodsColorDisabled,
}